var map = {
	"./activities.png": 4289,
	"./night-dance.png": 8463,
	"./radio/deejay.png": 5152,
	"./radio/virgin.png": 6139,
	"./rock.png": 9698,
	"./sunset-party.png": 1359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7181;